
var filterRange =  class {
    constructor(wrapper) {
        this._createElements(wrapper);
        this._addEvents();
    }

    _createElements(wrapper){
        this.wrapper = wrapper;
        this.minVal = wrapper.querySelector('[data-filterRange-min]');
        this.maxVal = wrapper.querySelector('[data-filterRange-max]');

        this.allBtn = wrapper.querySelector('[data-filterRange-allBtn]');
        this.cheapBtn = wrapper.querySelector('[data-filterRange-cheapBtn]');
        this.expensiveBtn = wrapper.querySelector('[data-filterRange-expensiveBtn]');

        this.cross = wrapper.querySelectorAll('[data-filterRange-cross]');

        this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.min = this.data.min;
        this.max = this.data.max;
    }

    _checkEmpty(el) {

        if ( !el ) {
            return;
        }

        let check = function (element) {
            if ( element.value != '') {
                element.parentNode.querySelector('[data-filterRange-cross]').style.display = 'block';
            } else {
                element.parentNode.querySelector('[data-filterRange-cross]').style.display = 'none';
            }
        };

        if ( Array.isArray(el) ) {
            el.forEach(function (item, i, arr) {
                check(item);
            });
        } else if (typeof el == 'object') {
            check(el);
        } else {
            console.error('ERROR:', 'param most be an array or object! get ' + typeof el );
        }
    };

    _compareMinMax(min, max){
        let tempMin = parseInt(min.value);
        let tempMax = parseInt(max.value);
        if ( parseInt(min.value) > 0 && parseInt(max.value) > 0 ) {
            if ( parseInt(min.value) > parseInt(max.value) ) {
                this.minVal.value = tempMax;
                this.maxVal.value = tempMin;
            }
        }
    };

    _checkMinMax(el) {
        if ( el.value < this.min ) {
            el.value = this.min;
        } else if ( el.value > this.max ) {
            el.value = this.max;
        }
    };

    _addEvents(){
        let self = this;

        this.minVal.addEventListener('keydown', (e) => {
            let arrCodes = [48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105,8,46,37,39];
            if ( arrCodes.indexOf(e.keyCode) === -1 ) {
                e.preventDefault();
            }
            if ( this.minVal.value.length >4 && (e.keyCode !== 8 && e.keyCode !==46 && e.keyCode !==37 && e.keyCode !==39 ) ) {
                e.preventDefault();
            }
        }, false);

        this.maxVal.addEventListener('keydown', (e) => {
            let arrCodes = [48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105,8,46,37,39];
            if ( arrCodes.indexOf(e.keyCode) === -1 ) {
                e.preventDefault();
            }
            if ( this.maxVal.value.length >4 && (e.keyCode !== 8 && e.keyCode !==46 && e.keyCode !==37 && e.keyCode !==39 ) ) {
                e.preventDefault();
            }
        }, false);

        this.minVal.addEventListener('change', () => {
            this._checkMinMax(this.minVal);
            this._checkEmpty(this.minVal);
            this._compareMinMax(this.minVal, this.maxVal);
        }, false);

        this.maxVal.addEventListener('change', () => {
            this._checkMinMax(this.maxVal);
            this._checkEmpty(this.maxVal);
            this._compareMinMax(this.minVal, this.maxVal);
        }, false);

        this.allBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.minVal.value = this.min;
            this.maxVal.value = this.max;
            this._checkEmpty([this.minVal, this.maxVal]);
        }, false);

        this.cheapBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.minVal.value = this.min;
            this.maxVal.value = this.data.cheapTo;
            this._checkEmpty([this.minVal, this.maxVal]);
        }, false);

        this.expensiveBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.minVal.value = this.data.expensiveFrom;
            this.maxVal.value = this.max;
            this._checkEmpty([this.minVal, this.maxVal]);
        }, false);

        this.cross.forEach((item, i, arr) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let input = item.parentNode.querySelector('input');
                input.value = '';
                this._checkEmpty(input);
            }, false);
        });
    }
    del(){

    }

};

export {filterRange};